import { PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import _ from 'lodash'
import { HyperLink } from '../../../Common/Form'
import { FormValueSelector } from '../../../Common/forms'
import {
  UPDATE_PROPOSAL_TYPE,
  UPDATE_PROPOSAL_TYPE_MAP
} from '../helper'
import styles from './index.css'

const DESC_PREFIX = '修改'

const DESC_SUFFIX = '提案'

// 取得標題上確認、檢視頁顯示子提案說明
// ex: 包含修改圖片 updateImageV2-649103、修改賣場影片 updateVideo-650816 與修改商品詳情 updateCopy-649102
export const getSubProposalsDesc = (subProposals) => {
  const subProposalsSize = _.size(subProposals)
  // 將子提案分成除了最後一筆和最後一筆組成說明最後再合併兩個說明
  const withoutLastSubProposalsDesc = _.flow(
    () => _.slice(subProposals, 0, subProposalsSize - 1),
    slicedSubProposals => _.map(slicedSubProposals, slicedSubProposal => {
      const { id, type } = slicedSubProposal
      return `${DESC_PREFIX}${UPDATE_PROPOSAL_TYPE_MAP[type]} ${type}-${id}`
    }),
    descs => {
      let desc = `包含${_.join(descs, '、')}`
      if (!_.isEmpty(descs)) {
        desc = `${desc} 與`
      }
      return desc
    }
  )()
  const lastSubProposalDesc = _.flow(
    () => _.get(subProposals, subProposalsSize - 1),
    (subProposal = {}) => {
      if (_.isEmpty(subProposal)) {
        return ''
      }

      const { id, type } = subProposal
      return `${DESC_PREFIX}${UPDATE_PROPOSAL_TYPE_MAP[type]} ${type}-${id}`
    }
  )()
  const subProposalsDesc = `${withoutLastSubProposalsDesc}${lastSubProposalDesc}`
  return subProposalsDesc
}

// 兼容確認頁紙顯示純文字、完成頁子提案編號顯示對應檢視頁連結
export const ConvertedDesc = props => {
  const { subProposals = [], withOverviewLink = false } = props
  // ex: 包含修改圖片 updateImageV2-649103 與修改商品詳情 updateCopy-649102
  const desc = getSubProposalsDesc(subProposals)
  // 找出字串裡全部符合 'updatexxx-12345' 的字串，ex: 'updateImageV2-649103', 'updateCopy-649102'
  const regexp = new RegExp(`([${_.join(_.keys(UPDATE_PROPOSAL_TYPE), '|')}]*.-\\d+)`, 'g')
  // ex: ['包含修改圖片', 'updateImageV2-649103', ' 與修改商品詳情 ', 'updateCopy-649102']
  const splitedDescs = _.split(desc, regexp)

  return (
    <>
      {splitedDescs.map((desc = '') => {
        const isTypeWithId = regexp.test(desc)
        if (isTypeWithId) {
          // 沒有轉換器直接輸出
          if (!withOverviewLink) {
            // 'updateCopy-650818' => ['-650818', '650818']
            return _.get(desc.match(/-(\d+)/), '1', '')
          }

          // 'updateCopy-650818' => ['updateCopy', '650818']
          const [type, id] = _.split(desc, '-')
          return (
            <HyperLink
              key={id}
              target='_blank'
              href={`../${UPDATE_PROPOSAL_TYPE[type]}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${id}`}
            >
              {id}
            </HyperLink>
          )
        }

        return desc
      })}
    </>
  )
}

const PageTitle = () => {
  return (
    <FormValueSelector
      selector={select => ({
        mainProposalId: select('proposal.id'),
        subProposals: select('proposal.subProposals')
      })}
    >
      {({ mainProposalId, subProposals = [] }) => {
        return (
          <>
            <p className={styles.title}>修改賣場資訊</p>
            <div className={styles.description}>
              <p>
                複合式提案，將包含
                {`${DESC_PREFIX}${UPDATE_PROPOSAL_TYPE_MAP.updateImageV2}${DESC_SUFFIX}、`}
                {`${DESC_PREFIX}${UPDATE_PROPOSAL_TYPE_MAP.updateListingAttribute}${DESC_SUFFIX}、`}
                {`${DESC_PREFIX}${UPDATE_PROPOSAL_TYPE_MAP.updateVideo}${DESC_SUFFIX}與`}
                {`${DESC_PREFIX}${UPDATE_PROPOSAL_TYPE_MAP.updateCopy}${DESC_SUFFIX}。`}
              </p>
              {
                !_.isUndefined(mainProposalId) && (
                  <p>
                    提案編號：
                    {mainProposalId}
                    {' ('}
                    <ConvertedDesc subProposals={subProposals} />
                    {')'}
                  </p>
                )
              }
            </div>
          </>
        )
      }}
    </FormValueSelector>
  )
}

export default PageTitle
